import {
    Component,
    ElementRef,
    Input,
    OnInit,
    Renderer2,
    ViewEncapsulation,
    ChangeDetectionStrategy,
    Injector,
    ChangeDetectorRef,
} from '@angular/core';
import { FiErrorMessageBase } from '@fi-shared/fi-error-message/fi-error-message-base';
import { NgControl, NgModel } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'fi-error-message',
    template: `
        @if (showHeader) {
          <p class="asteriskCcmIcon BrandedColorBefore">{{ 'common.missing_data' | fiAppText }}:</p>
        }
        
        @if (errorText) {
          <div>
            {{ errorText }}
          </div>
        }
        
        <ng-content></ng-content>
        `,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./fi-error-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-error-message' },
    standalone: false,
})
export class FiErrorMessageComponent extends FiErrorMessageBase implements OnInit {
    @Input() showHeader: boolean = true;
    @Input() errorText: string = '';
    @Input() fiErrorModel: NgControl;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
        private cdr: ChangeDetectorRef,
        injector: Injector,
    ) {
        super(injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.renderer.addClass(this.elementRef.nativeElement, 'ErrorMessage');

        if (this.fiErrorModel) {
            this.fiErrorModel.valueChanges.pipe(takeUntil(this.ngOnDestroy$)).subscribe(() => {
                this.errorText = this.getErrorMessage(this.fiErrorModel);
                if (this.errorText) {
                    this.renderer.removeClass(this.elementRef.nativeElement, 'ng-hide');
                } else {
                    this.renderer.addClass(this.elementRef.nativeElement, 'ng-hide');
                }
                this.cdr.markForCheck();
            });
        }
    }
}
